module.exports = __webpack_public_path__ + "static/media/edit-kn.3d5c45e1.svg";